import { render, staticRenderFns } from "./CategoryViewer.vue?vue&type=template&id=64586082&scoped=true&"
import script from "./CategoryViewer.vue?vue&type=script&lang=js&"
export * from "./CategoryViewer.vue?vue&type=script&lang=js&"
import style0 from "./CategoryViewer.vue?vue&type=style&index=0&id=64586082&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64586082",
  null
  
)

export default component.exports